import React from 'react';
import { isEmpty, memoize, orderBy } from 'lodash';
import styled from 'styled-components';
import {
  DIAMOND_PRODUCT_TYPE,
  productLocationTypes,
} from '../enum/api/productTypes';
import { parseEnumType } from './enumMappers';
import themeColors from '../../assets/styles/themeColors';

const Badge = styled.span`
  display: inline-block;
  width: 48px;
  height: 22px;
  border-radius: 6px;
  background-color: ${themeColors.colorFilterItemBackground};
  color: ${themeColors.colorWhite};
  font-size: 14px;
  text-align: center;
  font-weight: 600;
`;

const FilterLabelWrapper = styled.span`
  display: inline-block;
  vertical-align: middle;

  > span {
    margin-left: 6px;
  }
`;

export const filterItemByLabel = memoize(
  (items, products, attribute, limit, formatLabel) =>
    items
      .map((item) => {
        const filteredProducts = products.filter(
          (product) => product[attribute] === item.label,
        );

        return !filteredProducts.length
          ? null
          : {
              ...item,
              count: '',
              label: (
                <FilterLabelWrapper data-cy={`${item.label}`}>
                  {formatLabel ? formatLabel(item.label) : item.label}

                  {item.count && <span>{`(${filteredProducts.length})`}</span>}
                  {item.label === DIAMOND_PRODUCT_TYPE && <Badge>New</Badge>}
                </FilterLabelWrapper>
              ),
            };
      })
      .filter(Boolean),
);

export const filterItems = memoize(
  (
    items,
    attribute,
    products,
    formatLabel,
    limit,
    isMyHoldingsChecked,
    myHoldingsCodes,
  ) => {
    if (attribute !== 'Vaults.Location') {
      return filterItemByLabel(items, products, attribute, limit, formatLabel);
    }

    const equivalentLabels = {
      InstaVault: 'FractionalHoldings',
    };

    const getFormattedLabel = (label) => {
      if (label === 'FractionalHoldings') {
        return 'InstaVault';
      }
      return formatLabel ? formatLabel(label) : label;
    };

    const countsByLocation = items
      .map((item) => {
        const matches = (location) => {
          let locationLabel = parseEnumType(
            productLocationTypes,
            location.LocationType,
          );

          locationLabel = equivalentLabels[locationLabel] || locationLabel;

          const hasLocations = locationLabel === item.label;

          if (!isMyHoldingsChecked) {
            return hasLocations;
          }

          if (
            isMyHoldingsChecked &&
            !isEmpty(myHoldingsCodes) &&
            hasLocations
          ) {
            return myHoldingsCodes.some(
              (myHoldingCode) =>
                myHoldingCode.SymbolCode === location.SymbolCode,
            );
          }

          return hasLocations;
        };

        const filtered = products.filter(({ Locations }) =>
          Locations.some(matches),
        );

        return !filtered.length
          ? null
          : {
              ...item,
              label: (
                <FilterLabelWrapper data-cy={`${item.label}`}>
                  {getFormattedLabel(item.label)}
                  {item.count && <span>{`(${filtered.length})`}</span>}
                  {item.label === DIAMOND_PRODUCT_TYPE && <Badge>New</Badge>}
                </FilterLabelWrapper>
              ),
              count: '',
              // count: `(${filtered.length})`,
            };
      })
      .filter(Boolean);
    return orderBy(countsByLocation, ['label'], 'asc');
  },
);
